const USE_OPTIONS = [
  { value: 'true', label: '사용' },
  { value: 'false', label: '미사용' },
];

const USE_ACTIVE_OPTIONS = [
  { value: 'true', label: '활성' },
  { value: 'false', label: '비활성' },
];

const IMAGE_TEXT_OPTIONS = [
  { value: 'img', label: '이미지' },
  { value: 'text', label: '텍스트' },
];

// Manager field groups
export const managerMFields = [
  'M_ComCode',
  'M_ComName',
  'M_Domain',
  'M_Port',
  'M_UseExMail',
  'M_UseMail',
  'M_MailDomain',
  'M_MailSize',
  'M_MailPW',
  'M_DBName',
  'M_DBHost',
  'M_DBUser',
  'M_DBPW',
  'M_DBPort',
  'M_UseSSO',
  'M_RedirectSSO',
  'is_active',
];

export const managerLFields = [
  'L_LogoType',
  'L_LogoImgPath',
  'L_LogoText',
  'L_UseCR',
  'L_CRText',
  'L_SloganType',
  'L_SloganImgPath',
  'L_SloganText',
];

export const managerPFields = [
  'P_UseBanner',
  'P_BannerPath',
  'P_UseCR',
  'P_CRText',
  'P_LogoPath',
  'P_SLogoPath',
  'P_PortletTypeNum',
  'P_SelectPortlet',
  'P_SelectMenus',
];

export const managerPortalSplitFields = ['P_PortletTypeNum', 'P_SelectPortlet', 'P_SelectMenus'];

export const managerPortalPageFields = managerPFields.filter(
  field => !managerPortalSplitFields.includes(field)
);

// Portal layout definitions
export const PORTLET_LAYOUTS = {
  1: { rows: [1, 2] },
  2: { rows: [2, 1] },
  3: { rows: [2, 2] },
  4: { rows: [2, 3] },
  5: { rows: [3, 2] },
  6: { rows: [3, 3] },
};

export const DEFAULT_PORTLET_ITEMS = [
  { id: 'myProfile', label: '나의 프로파일정보' },
  { id: 'recentBoard', label: '최근 게시물 목록' },
  { id: 'recentAprv', label: '진행중 결재목록' },
  { id: 'chartTypeA', label: 'Column Chart' },
  { id: 'chartTypeB', label: 'Pie Chart' },
  { id: 'reservation', label: '자원예약' },
];

export let PORTLET_ITEMS = [...DEFAULT_PORTLET_ITEMS];

const DEFAULT_MANAGER_MENU_ITEMS = [
  { id: 'myDesk', label: 'My Desk' },
  { id: 'mail', label: '전자메일' },
  { id: 'approval', label: '전자결재' },
  { id: 'board', label: '게시판' },
  { id: 'reservation', label: '자원예약' },
  { id: 'schedule', label: '일정관리' },
];

export let MANAGER_MENU_ITEMS = [...DEFAULT_MANAGER_MENU_ITEMS];

const managerMenuActive = (value) => {
  if (value === true || value === 1) return true;
  const normalized = String(value ?? '').trim().toLowerCase();
  return normalized === '1' || normalized === 'true' || normalized === 'y' || normalized === 'yes';
};

export const setManagerMenuItemsFromDb = (menuRows) => {
  const mapped = (Array.isArray(menuRows) ? menuRows : [])
    .filter((row) => managerMenuActive(row?.is_active))
    .sort((a, b) => (a?.sort_order || 0) - (b?.sort_order || 0) || (a?.menu_id || 0) - (b?.menu_id || 0))
    .map((row) => ({
      id: String(row.menu_key || '').trim(),
      label: row.label || String(row.menu_key || '').trim(),
    }))
    .filter((item) => item.id);

  MANAGER_MENU_ITEMS = mapped.length > 0 ? mapped : [...DEFAULT_MANAGER_MENU_ITEMS];
  return MANAGER_MENU_ITEMS;
};

export const setPortletItemsFromDb = (portletRows) => {
  const mapped = (Array.isArray(portletRows) ? portletRows : [])
    .filter((row) => managerMenuActive(row?.is_active))
    .sort((a, b) => (a?.sort_order || 0) - (b?.sort_order || 0) || (a?.portlet_pk || 0) - (b?.portlet_pk || 0))
    .map((row) => ({
      id: String(row.portlet_id || '').trim(),
      label: String(row.portlet_label || '').trim(),
    }))
    .filter((item) => item.id);

  PORTLET_ITEMS = mapped.length > 0 ? mapped : [...DEFAULT_PORTLET_ITEMS];
  return PORTLET_ITEMS;
};

// Labels and input metadata
export const managerFieldLabels = {
  M_ComCode: '회사코드',
  M_ComName: '회사명',
  M_Domain: '도메인명',
  M_Port: '연결NodeJS포트',
  M_UseExMail: '외부메일',
  M_UseMail: '내부메일사용',
  M_MailDomain: '내부메일도메인',
  M_MailSize: '내부메일기본사용량(MB)',
  M_MailPW: '내부메일기본비밀번호',
  M_DBName: '회사기본DB명',
  M_DBHost: 'DB 호스트',
  M_DBUser: 'DB사용계정',
  M_DBPW: 'DB사용패스워드',
  M_DBPort: 'DB포트',
  M_UseSSO: 'SSO 사용',
  M_RedirectSSO: 'SSO 리다이렉트 사용',
  L_LogoType: 'Logo 타입',
  L_LogoImgPath: 'Logo 이미지경로',
  L_LogoText: 'Logo 텍스트',
  L_UseCR: 'Copyright 사용여부',
  L_CRText: 'Copyright 필드',
  L_SloganType: '슬로건 타입',
  L_SloganImgPath: '슬로건 이미지경로',
  L_SloganText: '슬로건 텍스트문구',
  P_UseBanner: '배너 사용유무 (상단고정)',
  P_BannerPath: '배너 이미지경로',
  P_UseCR: 'Copyright 사용여부',
  P_CRText: 'Copyright 필드',
  P_LogoPath: 'Fullsize Logo 이미지경로',
  P_SLogoPath: 'Thumnail Logo 이미지경로',
  P_PortletTypeNum: '포틀릿 템플릿 번호',
  P_SelectPortlet: '포틀릿 사용 번호',
  P_SelectMenus: 'Left메뉴 선택 항목',
  is_active: '활성 상태',
};

export const managerBooleanRadioFields = ['M_UseExMail', 'M_UseMail', 'M_UseSSO', 'M_RedirectSSO', 'L_UseCR', 'P_UseBanner', 'P_UseCR','is_active'];

export const managerFileFields = ['L_LogoImgPath', 'L_SloganImgPath', 'P_BannerPath', 'P_LogoPath', 'P_SLogoPath'];

export const managerRadioOptionsMap = {
  M_UseExMail: USE_OPTIONS,
  M_UseMail: USE_OPTIONS,
  M_UseSSO: USE_OPTIONS,
  M_RedirectSSO: USE_OPTIONS,
  L_UseCR: USE_OPTIONS,
  P_UseBanner: USE_OPTIONS,
  P_UseCR: USE_OPTIONS,
  is_active: USE_ACTIVE_OPTIONS,
  L_LogoType: IMAGE_TEXT_OPTIONS,
  L_SloganType: IMAGE_TEXT_OPTIONS,
};

export const managerToBoolean = value =>
  value === true || value === 1 || value === '1' || value === 'true';

export const managerToLayoutNumber = value => {
  const n = Number(value);
  return Number.isInteger(n) && PORTLET_LAYOUTS[n] ? n : 6;
};

export const getPortletItemLabelById = itemId => {
  const found = PORTLET_ITEMS.find(item => item.id === itemId);
  return found ? found.label : null;
};

export const parseManagerSelectedPortlet = (rawValue, layoutNum) => {
  if (!rawValue) return {};

  let parsed;
  try {
    parsed = typeof rawValue === 'string' ? JSON.parse(rawValue) : rawValue;
  } catch {
    return {};
  }

  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};

  const rows = PORTLET_LAYOUTS[layoutNum]?.rows || [];
  const validKeys = new Set();
  rows.forEach((cols, rowIdx) => {
    for (let c = 0; c < cols; c += 1) {
      validKeys.add(`${rowIdx}-${c}`);
    }
  });

  const result = {};
  Object.entries(parsed).forEach(([key, value]) => {
    if (!validKeys.has(key)) return;

    const raw = typeof value === 'string' ? value : value?.id || value?.label;
    if (!raw) return;

    const found = PORTLET_ITEMS.find(item => item.id === raw || item.label === raw);
    if (!found) return;

    result[key] = {
      id: found.id,
      label: found.label,
    };
  });

  return result;
};

export const serializeManagerSelectedPortlet = zoneData => {
  const result = {};
  Object.entries(zoneData || {}).forEach(([key, value]) => {
    if (value?.id) result[key] = value.id;
  });
  return Object.keys(result).length ? JSON.stringify(result) : '';
};

export const getManagerPortletLabelByStoredValue = raw => {
  if (!raw) return '';
  const found = PORTLET_ITEMS.find(item => item.id === raw || item.label === raw);
  return found ? found.label : String(raw);
};

export const getManagerMenuLabelByStoredValue = (raw, menuItems = MANAGER_MENU_ITEMS) => {
  if (!raw) return '';
  const found = (menuItems || MANAGER_MENU_ITEMS).find(item => item.id === raw || item.label === raw);
  return found ? found.label : String(raw);
};

export const parseManagerSelectedMenus = (rawValue, menuItems = MANAGER_MENU_ITEMS) => {
  if (!rawValue) return [];

  let parsed = rawValue;
  if (typeof rawValue === 'string') {
    try {
      parsed = JSON.parse(rawValue);
    } catch {
      parsed = rawValue
        .split(',')
        .map(value => value.trim())
        .filter(Boolean);
    }
  }

  const values = Array.isArray(parsed) ? parsed : [];
  return values
    .map(raw => {
      const found = (menuItems || MANAGER_MENU_ITEMS).find(item => item.id === raw || item.label === raw);
      return found ? { id: found.id, label: found.label } : null;
    })
    .filter(Boolean);
};

export const serializeManagerSelectedMenus = menuItems => {
  const values = (menuItems || []).map(item => item?.id).filter(Boolean);
  return values.length ? JSON.stringify(values) : '';
};

export const managerIsRadioChecked = (field, optValue, formValue) =>
  managerBooleanRadioFields.includes(field)
    ? managerToBoolean(formValue) === (optValue === 'true')
    : formValue === optValue;

// Single source of manager create/edit default values
export const managerInitialForm = (() => {
  const form = {};
  [...managerMFields, ...managerLFields, ...managerPFields].forEach(field => {
    form[field] = '';
  });

  form.M_DBPort = 3306;
  form.M_Port = '';
  form.M_UseExMail = false;
  form.M_UseMail = true;
  form.M_MailSize = 1024;
  form.L_UseCR = true;
  form.P_UseBanner = false;
  form.P_UseCR = true;
  form.is_active = true;

  return form;
})();
